import * as Yup from 'yup';
import { invalidDate, requiredField, maxFiles } from './utils/messages';

export const demandsValidationSchema = Yup.object().shape({
  client: Yup.object().required(requiredField).typeError(requiredField),
  demanda: Yup.string().required(requiredField),
  serviceType: Yup.object().required(requiredField).typeError(requiredField),
  areaInterna: Yup.object().required(requiredField).typeError(requiredField),
  areaDemandante: Yup.string().required(requiredField),
  autorDemanda: Yup.string().required(requiredField),
  consumoHoras: Yup.boolean().required(requiredField),
  descricaoTrabalho: Yup.string().required(requiredField),
  lawyer: Yup.object().required(requiredField).typeError(requiredField),
  prazoAtendimento: Yup.string().required(requiredField),
  prazo: Yup.string().when('prazoAtendimento', (pA: any) => {
    if (pA !== 'SLA') return Yup.string().min(10, invalidDate).required(requiredField);
    return Yup.string().notRequired();
  }),
});

export const clientDemandsValidationSchema = Yup.object().shape({
  demanda: Yup.string().required(requiredField),
  serviceType: Yup.string().required(requiredField),
  tipoConsulta: Yup.string().test('isRequired', requiredField, function (item) {
    if (this.parent.serviceType === '2' && !item) return false;
    return true;
  }),
  tipoAvaliacao: Yup.string().test('isRequired', requiredField, function (item) {
    if (this.parent.serviceType !== '2' && this.parent.serviceType !== undefined && !item)
      return false;
    return true;
  }),
  consumoHoras: Yup.boolean().required(requiredField),
  descricaoTrabalho: Yup.string()
    .test('len', 'Quantidade máxima de 1024 caracteres', val => !!val && val.length <= 1024)
    .required(requiredField),
  prazoAtendimento: Yup.string().required(requiredField),
  prazo: Yup.string().when('prazoAtendimento', (pA: any) => {
    if (pA !== 'SLA') return Yup.string().min(10, invalidDate).required(requiredField);
    return Yup.string().notRequired();
  }),
  files: Yup.array().max(10, maxFiles).notRequired(),
});
